import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const StaffOnlyRoute = ({ children }) => {
  const { user } = useAuth();

  // Owner ise dashboard'a yönlendir
  if (user?.isOwner) {
    return <Navigate to="/owner" replace />;
  }

  return children;
};

export default StaffOnlyRoute;
